"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DashboardRemove_1 = require("./DashboardRemove");
var DashboardRemoveStore = new DashboardRemove_1.DashboardRemove();
exports.DashboardRemoveStore = DashboardRemoveStore;
